import React, { useState } from 'react';
import { RiAlertFill, RiSubtractLine, RiAddLine, RiFlag2Line } from '@remixicon/react';

/**
 * StatusBar Component
 * Displays maintenance status bar and Report AOG button at bottom of left panel
 */
const StatusBar = ({ maintenanceCount = 0 }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="space-y-3">
      {maintenanceCount > 0 && (
        <div className="bg-red-50 border border-red-200 rounded-xl p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <RiAlertFill className="w-4 h-4 text-red-500" />
              <span className="text-sm font-semibold text-red-800">Aircraft Under Maintenance</span>
            </div>
            <button
              onClick={() => setExpanded(!expanded)}
              className="p-1 hover:bg-red-100 rounded transition-colors"
            >
              {expanded ? (
                <RiSubtractLine className="w-4 h-4 text-red-400" />
              ) : (
                <RiAddLine className="w-4 h-4 text-red-400" />
              )}
            </button>
          </div>
          {expanded && (
            <p className="text-xs text-red-600 mt-2">
              {maintenanceCount} flight{maintenanceCount !== 1 ? 's' : ''} currently affected. Consider using Airport Search to find replacement aircraft.
            </p>
          )}
        </div>
      )}

      {/* Report AOG Button */}
      <button className="w-full flex items-center justify-center gap-2 py-2.5 border border-red-200 rounded-full text-red-600 text-sm font-medium hover:bg-red-50 transition-colors">
        <RiFlag2Line className="w-4 h-4" />
        Report AOG
      </button>
    </div>
  );
};

export default StatusBar;
